var cookieHelper = require("./cookieHelper").default

export default {
    run: function (router) {

        if (cookieHelper.getCookie('token') == '') {
            console.log('middleware - not logged in')
            router.push('/login')
        }
        else {
            console.log('middleware - logged in')
        }
    }
}
